'use client';

import React, { FC, JSX, ReactNode } from 'react';
import { Overlay } from '@ibe/components';

interface Props {
  text?: string;
  markup?: ReactNode;
  positionFixed?: boolean;
  fullOpacity?: boolean;
  customSpinner?: ReactNode;
  backdropProps?: React.HTMLAttributes<HTMLDivElement>;
  spinnerContainer?: React.HTMLAttributes<HTMLDivElement>;
  backgroundColor?: string;
  className?: string;
  zIndex?: number;
}

const ClientOverlay: FC<Props> = (props): JSX.Element => {
  return <Overlay {...props} />;
};

export default ClientOverlay;
